
<template>
    <div class="flex flex-row items-center px-2 rounded-full shadow bg-white">
        <Avatar :member="data"/>
        <span class="ml-2">{{data.name}}</span>
    </div>
</template>

<script>
    import Avatar from "../../components/Avatar";

    export default {
        name: "TestLeft",
        components: {Avatar},
        props: {
            data:Object,
        },
    };
</script>

<style  scoped>
    .name{
        display: flex;
        box-sizing: border-box;
        overflow: hidden;
        height: 100%;
        width: 100%;
        padding: 0 5px 0 0;
        border-radius: 8px 0 0 8px;
        align-items: center;
    }
    .colorBar{
        width: 10px;
        height: 100%;
    }
    .carId{
        flex: 1;
    }
    .type{
        padding: 0 5px 0 0 ;
        font-size: 1.2rem;
    }
</style>
